import { connect } from 'react-redux'
import {
  saveAndSendInvoicePDF,
  InvokeExpenseReminder,
  closeInvoiceReviewSnackBar,
  saveInvoiceDraft,
  generateInvoicePDF,
  navigateToUpdateBankInfo,
  cancelExpenseReminder,
  removeInvoiceAttachments,
  cancelEditInvoice,
  loadInvoiceItems,
  editAndGoToInvoice,
  getLogo,
  getUserCompanyUpdateInfo,
  getAttachedJournalPdfData
} from '../../actions'
// import { formatFiToISO } from '../../utils/DateTimeFormat'
import InvoiceReview from '../../components/invoice/invoiceReview.component'

const mapStateToProps = (state) => {
  const review = state.invoiceReviews
  const attachments = review.attachments
  const invoice = review.formValues
  const invoice_lang = invoice?.invoice_lang
  const isAddWorkshiftJournal = invoice?.addWorkshiftJournal

  let files = []

  if (attachments.length > 0) {
    files = attachments.map((a) => a.filename)
  }

  const attachedWorkShiftJournalIds = state.invoice.attachedWorkShiftJournalIds
  const workshift_journal_data = state.workShiftUser.workshift_journal
  const attachedWorkshiftJournal_data = workshift_journal_data.filter((item) =>
    attachedWorkShiftJournalIds.includes(item.journal_id)
  )

  return {
    apiFailed: review.apiFailed,
    apiSuccess: review.apiSuccess,
    apiSendSuccess: review.apiSendSuccess,
    showSpinner: review.showSpinner,
    invoiceRows: review.reviewRows,
    isSaveAndSend: review.isSaveAndSend,
    isExpenseReminder: state.invoiceReviews.isExpenseReminder,
    isNavigateToUpdateBankInfo: state.invoiceReviews.isNavigateToUpdateBankInfo,
    files: files,
    invoice: invoice,
    limitExceedError: review.limitExceedError,
    logo: state.logo.logo,
    attachedWorkshiftJournal: attachedWorkShiftJournalIds,
    attachedWorkshiftJournal_data: attachedWorkshiftJournal_data,
    invoice_lang: invoice_lang,
    isAddWorkshiftJournal: isAddWorkshiftJournal
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    saveAndSendInvoicePDF: (formValues) =>
      dispatch(saveAndSendInvoicePDF(formValues)),
    saveInvoiceDraft: (formValues) => dispatch(saveInvoiceDraft(formValues)),
    generateInvoicePDF: (invoice_id) =>
      dispatch(generateInvoicePDF(invoice_id)),
    closeSnackbar: () => dispatch(closeInvoiceReviewSnackBar()),
    navigateToUpdateBankInfo: (formValues) =>
      dispatch(navigateToUpdateBankInfo(formValues)),
    InvokeExpenseReminder: () => dispatch(InvokeExpenseReminder()),
    cancelExpenseReminder: () => dispatch(cancelExpenseReminder()),
    removeInvoiceAttachments: () => dispatch(removeInvoiceAttachments()),
    cancelEditInvoice: () => dispatch(cancelEditInvoice()),
    loadInvoiceItems: () => dispatch(loadInvoiceItems()),
    editAndGoToInvoice: (formValues, invoiceEdit) =>
      dispatch(editAndGoToInvoice(formValues, invoiceEdit)),
    getLogo: (data) => dispatch(getLogo(data)),
    getUserCompanyUpdateInfo: () => dispatch(getUserCompanyUpdateInfo()),
    getAttachedJournalPdfData: (data) =>
      dispatch(getAttachedJournalPdfData(data))
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const InvoiceReviewContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InvoiceReview)

export default InvoiceReviewContainer
